export enum AddCompanyCardType {
  FULLY_OPERATIONAL_CARD = 'FULLY_OPERATIONAL_CARD',
  COMPANY_CARD = 'COMPANY_CARD',
}
